"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapWorkspaces = void 0;
const merge_1 = __importDefault(require("lodash/merge"));
const workspaceDefaultProperties_1 = require("../../../workspaces/workspaceDefaultProperties");
function mapWorkspaces(workspaces, options = {}) {
    const { mergeWithDefaultProperties = true, ignoreKeys = {}, source, } = options;
    const mapObject = {};
    const sourceObject = source ? { source } : {};
    for (const key in workspaces) {
        if (!(key in ignoreKeys)) {
            if (mergeWithDefaultProperties) {
                mapObject[key] = (0, merge_1.default)({}, workspaceDefaultProperties_1.workspaceDefaultProperties, workspaces[key], sourceObject);
            }
            else {
                mapObject[key] = { ...workspaces[key], ...sourceObject };
            }
        }
    }
    return mapObject;
}
exports.mapWorkspaces = mapWorkspaces;
